<!--
 * @Author: xutao
 * @Date: 2023-03-07 12:05:37
 * @LastEditors: 梅爽
 * @LastEditTime: 2024-09-10 10:32:29
 * @FilePath: \homesite-web\src\components\wisdomBanner\index.vue
 * @Description:
 *
 * Copyright (c) 2023 by 用户/公司名, All Rights Reserved.
-->
<template>
  <div class="data_container">
    <div class="data_header">
      文化遗产数字化
    </div>
    <div class="data_desc">
      高精度三维建模技术，服务于文化遗产数字化保护、展示与传承
    </div>
    <div class="data_tab">
      <div
        class="tab_item cp"
        :class="{ tab_item_active: isActiveTab === 0 }"
        @click="setCarousel(0)"
      >
        文物数字化保护
      </div>
      <!-- <img class="img_gap" src="/static/images_20230306/dot.webp" alt=""> -->
      <div
        class="tab_item cp"
        :class="{ tab_item_active: isActiveTab === 1 }"
        @click="setCarousel(1)"
      >
        智慧博物馆
      </div>
    </div>
    <div class="swiper_content">
      <div
        class="swiper_container"
        style="position: absolute;left: 51%;transform: translateX(-53%);width: 2400px;height: 720px"
      >
        <div class="swiper-wrapper">
          <div
            class="swiper-slide"
            v-for="(item, index) in dataImg"
            :key="index"
          >
            <div class="top-banner-video" v-if="index == 0">
              <video
                ref="myVideo"
                style="width: 1200px; height: 720px; object-fit: fill"
                :src="item"
                poster="/static/images_20230306/首页/武当山封面.webp"
                autoplay
                muted
                loop
              >
                您的浏览器不支持 video
              </video>
              <!-- <img src="/static/images_20230306/playBtn.webp" :class="{ 'fade-out': videoState }" @click="operateVideo"
                alt="">
              <div @click="operateVideo" class="bg"></div> -->
            </div>
            <div class="swiper_slide_img" v-else>
              <div
                class="img"
                :style="
                  'background-image: url(' +
                    item +
                    '); background-size: cover; background-position: center; width:1200px; height:720px;'
                "
              ></div>
            </div>
          </div>
        </div>
      </div>
      <!-- //按钮 -->
      <div class="lbt_l cp" @click="slideChange(1)">
        <!-- <span style="font-size: 20px;color:#bababa;font-weight: 800" class="el-icon-arrow-left"></span> -->
        <img src="/static/images_2023_5_18/4.svg" />
      </div>
      <div class="lbt_r cp" @click="slideChange(2)">
        <!-- <span style="font-size: 20px;color:#bababa;font-weight: 800" class="el-icon-arrow-right"></span> -->
        <img src="/static/images_2023_5_18/5.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/swiper.min.css";
import Swiper from "swiper";

export default {
  name: "wisdom-banner",
  props: {},
  data() {
    return {
      isActiveTab: 0,
      mySwiper: null,
      videoState: false,
      dataImg: [
        "https://ds-rebuild-prod-1301434080.cos.ap-guangzhou.myqcloud.com/common/video/homesite/video/武当山.mp4",
        "/static/images_20230306/首页/wisdom.webp"
      ]
    };
  },
  mounted() {
    this.mySwiper = new Swiper(".swiper_container", {
      slidesPerView: 2,
      spaceBetween: 0,
      centeredSlides: true,
      centeredSlidesBounds: true,
      loop: true,
      pagination: {
        el: ".swiper-pagination",
        clickable: true
      }
    });
  },
  methods: {
    slideChange(n) {
      if (n == 1) {
        //上一个
        this.mySwiper.slidePrev(1000);
      } else {
        //下一个
        this.mySwiper.slideNext(1000);
      }
      this.isActiveTab = this.mySwiper.realIndex;
    },
    setCarousel(val) {
      this.isActiveTab = val;
      this.mySwiper.slideToLoop(val, 1000, false);
    },
    operateVideo() {
      if (this.$refs.myVideo[0].paused) {
        this.$refs.myVideo[0].play();
        this.videoState = true;
      } else {
        this.$refs.myVideo[0].pause();
        this.videoState = false;
      }
    }
  }
};
</script>
<style scoped lang="scss">
.swiper_content {
  position: relative;
  height: 720px;
}

.swiper-slide {
  display: flex;
  text-align: center;
  font-size: 18px;
  margin: 10px;
  /* background: #fff; */
  /* Center slide text vertically */
  display: -webkit-box;
  display: -ms-flexbox;
  display: -webkit-flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  -webkit-justify-content: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  -webkit-align-items: center;
  align-items: center;
  transition: 300ms;
  transform: scale(1);
}

.swiper_slide_img {
  display: flex;
  /* padding: 10px; */
  /* background-color: #ffffff; */
}

.swiper-slide-active,
.swiper-slide-duplicate-active {
  transform: scale(1);
}

.data_header {
  display: flex;
  justify-content: center;
  font-size: 48px;
  font-weight: bold;
  text-align: center;
  margin-top: 100px;
}

.data_desc {
  display: flex;
  justify-content: center;
  font-size: 20px;
  margin-top: 15px;
}

.data_tab {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px auto;
  width: 1200px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.26);
}

.tab_item {
  /* width: 160px; */
  height: 40px;
  /* border-radius: 20px; */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px 0px;
  margin: 0 78px;
  /* gap: 10px; */
  box-sizing: border-box;
  /* border: 1px solid rgba(0, 0, 0, 0.9); */
}

/* .tab_item:hover {
  color: #1472E2;
  border: 1px solid #1472E2;
} */

.img_gap {
  margin: 0 50px;
}

.lbt_l,
.lbt_r {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  width: 50px;
  height: 50px;
  /* background-color: #fff;
  border-radius: 50%; */
  z-index: 99;
  transform: translateY(-50%);
}

.lbt_l {
  left: calc(((100% - 1200px) / 2) + 64px);
}

.lbt_r {
  right: calc(((100% - 1200px) / 2) + 64px);
}

.tab_item_active {
  color: #1472e2;
  border-bottom: 2px solid #1472e2;
}

.top-banner-video {
  position: relative;
}

.top-banner-video img {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.fade-out {
  display: none;
}

.bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
}

@media screen and (max-width: 1440px) {
  .data_header {
    font-size: 36px;
    font-weight: 700;
    line-height: 42.19px;
    letter-spacing: 0.02em;
  }
  .product-content {
    .row {
      height: 376px;

      &.sp {
        height: 487px;

        .card .info {
          padding-top: 37px;
        }
      }

      .card {
        .info {
          padding: 130px 0 0 61px;

          > div {
            &:nth-child(1) {
              font-size: 32px;
              font-weight: 700;
              line-height: 37.5px;
              letter-spacing: -0.03em;
            }
            &:nth-child(2) {
              font-size: 16px;
              font-weight: 400;
              line-height: 18.75px;
              margin-top: 8px;
            }
            &:nth-child(3) {
              width: 72px;
              height: 27px;
              line-height: 25px;
              margin-top: 21px;
              font-size: 10px;
            }
          }
        }
      }
    }
  }
  .data_desc {
    font-size: 16px;
    font-weight: 400;
    line-height: 18.75px;
    margin-top: 10px;
  }
  .news-dynamic {
    height: 260px;

    .news-desc {
      width: 302px;

      .news-desc-container {
        font-size: 36px;
        line-height: 42.19px;

        .news-more {
          font-size: 12px;
          font-weight: 400;
          line-height: 14.06px;
        }

        .news-more {
          bottom: 10px;
        }
      }
    }

    .news-container {
      width: calc(100% - 302px);

      .news-content {
        .news-card {
          width: 319px;
          height: 137px;

          .news-card-img {
            width: 319px;
            height: 137px;
          }

          .news-card-desc {
            top: 144px;
            font-size: 12px;
            font-weight: 400;
            line-height: 14.06px;

            img {
              height: 14px;
            }
          }
        }
      }
    }
  }
  .programme_box {
    .t1 {
      font-size: 24px;
      font-weight: 700;
      line-height: 28.13px;
      margin-top: 53px;
      height: 24px;
    }

    .t2 {
      font-size: 14px;
      font-weight: 400;
    }

    .t3 {
      font-size: 12px;
      font-weight: 400;
      line-height: 14.06px;
    }
  }
  .swiper_content {
    height: 540px !important;

    .swiper_container,
    .swiper-container2 {
      width: 1800px !important;
      height: 540px !important;
      left: 50% !important;

      .swiper-slide {
        width: 900px !important;
        height: 540px !important;

        .swiper_slide_img {
          .img {
            width: 900px !important;
            height: 540px !important;
          }
        }
        .top-banner-video {
          video {
            width: 900px !important;
            height: 540px !important;
          }
        }
      }
    }
  }
  .lbt_l {
    left: calc(((100% - 900px) / 2) + 64px) !important;
  }
  .lbt_r {
    right: calc(((100% - 900px) / 2) + 64px) !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/wisdomBanner/index.vue